var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 3.67467L8.649 0.119111C8.58 0.0426667 8.4885 0 8.394 0H0.375C0.168 0 0 0.199111 0 0.444444V7.55556C0 7.80089 0.168 8 0.375 8H8.394C8.4885 8 8.58 7.95733 8.649 7.88089L11.88 4.32533C11.9565 4.24178 12 4.12356 12 4C12 3.87644 11.9565 3.75822 11.88 3.67467Z",
    fill: "#FFAB01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagYellow);
export default __webpack_public_path__ + "static/media/tag_yellow.21874d086ffd4fbe9c88308bd1e3808d.svg";
export { ForwardRef as ReactComponent };